import { defineStore } from "pinia";
export const useAppConfigStore = defineStore("config", {
  state: () => ({
    data: {
      openDataPrefix: "https://opendata.dbd.go.th/dataset/",
      env: "PROD",
      version: "1.0.0",
      hotline: "1570",
      mail: "bdex@dbd.go.th",
      workingDate: "จันทร์ - ศุกร์: 8:30 - 16:30",
      contactOrg: "กรมพัฒนาธุรกิจการค้า",
      contactAddress: "563 ถนน นนทบุรี ตำบลบางกระสอ อำเภอเมืองนนทบุรี จังหวัดนนทบุรี 11000",
      fbLink: "https://www.facebook.com/dbd",
      twitterLink: "https://twitter.com/dbd",
      youtubeLink: "https://www.youtube.com/dbd",
      dataProtectionLink: "https://www2.dbd.go.th/download/PDF_law/dbd_policy_pdpa64.pdf",
      feeRateLink: "https://www2.dbd.go.th/download/PDF_law/lawdbd_moc_disc_ratefree_63.PDF",
      privacyPolicyLink: "https://www.dbd.go.th/storage/manual/29b57fa9-465f-49fc-bbc1-b195fdb84da2.pdf",
      termsOfUseLink: "https://www2.dbd.go.th/download/PDF_law/secuerity.pdf",
      dataProtectionUpdateDate: "2021-11-02",
      feeRateUpdateDate: "2020-12-26",
      privacyPolicyUpdateDate: "2023-09-18",
      termsOfUseUpdateDate: "2018-04-25",
      dataProtectionTitle: "แนวนโยบายในการคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2564",
      feeRateTitle: "กฎกระทรวงกำหนดอัตราค่าธรรมเนียมการจดทะเบียน การขอตรวจเอกสาร การขอสําเนาเอกสารพร้อมคำรับรอง และค่าธรรมเนียมอื่นที่เกี่ยวกับห้างหุ้นส่วนและบริษัทจำกัด พ.ศ. 2563",
      privacyPolicyTitle: "แนวนโยบายและแนวปฏิบัติในการเปิดเผยและนำข้อมูลไปใช้",
      termsOfUseTitle: "แนวนโยบายและแนวปฏิบัติในการรักษาความปลอดภัยด้านสารสนเทศ พ.ศ. 2561",
      headerRightText: 'Go Digital: ยกระดับการให้บริการด้วยเทคโนโลยีดิจิทัลอย่างเต็มรูปแบบ'
    }
  }),
  actions: {},
  getters: {}
});
